//#region src/utils/objects.ts
var e = (e, t) => {
	let n = {}, r = Math.min(e.length, t.length), i = (e) => typeof e == "string" && e !== "", a = (e) => /^\d+$/.test(e), o = (e, t, n) => {
		if (t.length === 1) {
			let r = t[0];
			a(r) && Array.isArray(e) ? e.length === 0 && (e[Number(r)] = n) : e[r] = n;
			return;
		}
		let r = t[0], i = t.slice(1), s = i[0];
		r in e || (e[r] = a(s) ? [] : {}), o(e[r], i, n);
	};
	for (let a = 0; a < r; a++) {
		let r = e[a], s = t[a];
		s?.keyword === "if" && s.params?.failingKeyword === "then" || i(r) && o(n, r.split("."), s);
	}
	return n;
};
function t(e) {
	if (e && typeof e == "object") {
		let n = { ...e };
		for (let e in n) {
			let r = n[e];
			r === null ? n[e] = void 0 : typeof r == "object" && t(r);
		}
		return n;
	}
	return e;
}
//#endregion
export { e as n, t };

//# sourceMappingURL=objects-MUGf6OMx.js.map